
import { palette } from './brand/specs';
// import * as brands from '@tuscany/ixl-frontend-themes';

const spacingBaseline = 1;

const CarbonVars = {
  // Brand colors
  brand01: palette.primary,
  brand02: palette.secondary,
  brand03: palette.tertiary,
  brand04: palette.black,

  // Background colors
  uiBackground: palette.secondary,
  ui01: palette.ui.light,
  ui02: palette.ui.med,
  ui03: palette.ui.dark,
  overlay01: `${palette.ui.light}`,

  // Supporting Brand colors
  support01: palette.notifications.error, // Error
  support02: palette.accent01, // Success
  support03: palette.accent03, // Warning
  support04: palette.accent04, // Information
  support05: palette.accent05,
  support06: palette.accent06,

  // Interactive colors
  activePrimary: palette.darkPrimary,
  disablePrimary: palette.lightPrimary,
  focusPrimary: palette.darkPrimary,
  hoverPrimary: palette.darkPrimary,
  hoverPrimaryText: palette.secondary,
  activeSecondary: palette.secondary,
  hoverSecondary: palette.secondary,
  hoverSecondaryText: palette.darkPrimary,
  activeTertiary: palette.tertiary,
  hoverTertiary: palette.tertiary,
  activeUi: palette.ui.med,
  hoverUi: palette.ui.med,
  selectedUi: palette.ui.med,
  disabled: palette.ui.light,
  highlight: palette.accent04,
  danger: palette.accent02,
  skeleton01: palette.ui.light,
  skeleton02: palette.ui.med,
  lightYellow: palette.lightYellow,
  errorBorder: palette.errorBorder,
  errorBackground: palette.errorBackground,
  categoryCardBackground: palette.categoryCardBackground,
  infoBlueBackground: palette.infoBlueBackground,
  infoBlueBorder: palette.infoBlueBorder,

  error: palette.notifications.error,
  warning: palette.notifications.warning,
  success: palette.notifications.success,
  info: palette.notifications.info,
  note: palette.notifications.note,

  // Text colors
  text01: palette.text.text01,
  text02: palette.text.text02,
  text03: palette.text.text03,
  text04: palette.text.text04,
  text05: palette.text.text05,
  text06: palette.text.text06,

  // Link colors
  link01: palette.primary,

  // Neutrals and  grays
  grey60: palette.neutrals.grey60,
  grey200: palette.neutrals.grey200,
  grey300: palette.neutrals.grey300,
  grey600: palette.neutrals.grey600,
  grey700: palette.neutrals.grey700,
  grey800: palette.neutrals.grey800,
  grey900: palette.neutrals.grey900,
  black: palette.neutrals.black,
  silver: palette.metallic.silver,

  // 8px-based grid is commonly used for layout and spacing
  spacing3xs: `${spacingBaseline * 0.125}rem`,
  spacing2xs: `${spacingBaseline * 0.25}rem`,
  spacingXs: `${spacingBaseline * 0.5}rem`,
  spacingSm: `${spacingBaseline * 0.75}rem`,
  spacingMd: `${spacingBaseline}rem`,
  spacingLg: `${spacingBaseline * 1.5}rem`,
  spacingXl: `${spacingBaseline * 2}rem`,
  spacing2xl: `${spacingBaseline * 2.5}rem`,
  spacing3xl: `${spacingBaseline * 3}rem`,

  layout2xs: `${spacingBaseline * 3}rem`,
  layoutXs: `${spacingBaseline * 3.5}rem`,
  layoutSm: `${spacingBaseline * 4}rem`,
  layoutMd: `${spacingBaseline * 5}rem`,
  layoutLg: `${spacingBaseline * 6}rem`,
  layoutXl: `${spacingBaseline * 6.5}rem`,
  layout2xl: `${spacingBaseline * 8}rem`,

  // horizontal spacing uses a 5px-based grid in accordance to BP design system
  horizontalSpacingXs: `${spacingBaseline * 0.3125}rem`,
  horizontalSpacingSm: `${spacingBaseline * 0.625}rem`,
  horizontalSpacingMd: `${spacingBaseline * 0.9375}rem`,
  horizontalSpacingLg: `${spacingBaseline * 1.25}rem`,
  horizontalSpacingXl: `${spacingBaseline * 1.5625}rem`,
  horizontalSpacing2xl: `${spacingBaseline * 1.875}rem`,
  horizontalSpacing3xl: `${spacingBaseline * 2.5}rem`,

  horizontalLayoutXs: `${spacingBaseline * 2.8125}rem`,
  horizontalLayoutSm: `${spacingBaseline * 3.75}rem`,
  horizontalLayoutMd: `${spacingBaseline * 5.9375}rem`,
  horizontalLayoutLg: `${spacingBaseline * 7.8125}rem`,
  horizontalLayoutXl: `${spacingBaseline * 11.875}rem`,
  horizontalLayout2xl: `${spacingBaseline * 17.8125}rem`,
  horizontalLayout3xl: `${spacingBaseline * 20.425}rem`
};

export default CarbonVars;
